import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fw-bold mb-1 text-nowrap" }
const _hoisted_2 = { class: "fw-bold mb-1 text-nowrap" }
const _hoisted_3 = {
  key: 0,
  class: "fs-smaller"
}
const _hoisted_4 = { class: "display-5" }

import { PropType } from "vue";
import Help from "@/guiide/components/common/Help.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DBOptionsStat',
  props: {
    label: { type: String, required: true },
    helpText: { type: Array as PropType<string[]>, required: true },
    value: { type: String, required: true },
    subHeading: { type: String, required: false },
    showSubHeading: { type: Boolean, required: false, default: true }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("div", _hoisted_2, [
      (__props.subHeading && __props.showSubHeading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.subHeading), 1))
        : _createCommentVNode("", true),
      _cache[0] || (_cache[0] = _createTextVNode("  ")),
      _createVNode(Help, {
        title: __props.label,
        text: __props.helpText
      }, null, 8, ["title", "text"])
    ]),
    _createElementVNode("h3", _hoisted_4, _toDisplayString(__props.value), 1)
  ], 64))
}
}

})